import "./VideoPlayer.scss";
import trebleClef from "../../assets/images/treble-clef-no-bgd.jpg";

import React, { useState } from "react";

const videos = [
  "tSv04ylc6To",
  "Az11r3EKmbg",
  "QK6OpqAhbuU",
  "Kb-0Eo0Yk0o",
  "a0hp60WW6lQ",
  "sySlY1XKlhM",
  "1SiylvmFI_8",
  "4G-YQA_bsOU",
  "YnSwODZc05c",
  "ndUCNnhH03Q",
  "tOq-Z_p7WDg",
  "yfSny4MkS3c",
  "4cffzyPQcGs",
  "hvjjWdQeKHU",
  "9GlNPmiE_gQ",
  "IT8XvzIfi4U",
  "_X7SgllcCSE",
  "IXdNnw99-Ic",
  "Gl2sqdfD2Q0",
  "cQ78pDGoIAI",
  "fzQJdInQia0",
  "0-8Tp0IVSl8",
  "uxf1FUU8mk0",
  "OkN5IGIkfa4",
  "J65GxJ2v9Wg",
  "x77dBXEZs8I",
  "hARz7Ymilqo",
  "RjriWGxk7Ps",
  "aXIDAd68ThI",
  "VsTi3UQvg6w",
  "GHPVC2-yA5Q",
];

function VideoPlayer() {
  const [activeVideo, setActiveVideo] = useState(null);
  return (
    <div className="video-player">
      <div className="video-player__container">
        <h1 className="video-player__title">
          <img
            className="video-player__treble-clef"
            src={trebleClef}
            alt="Treble Clef"
          />
          Rhythms of Renewal
          <img
            className="video-player__treble-clef-aft"
            src={trebleClef}
            alt="Treble Clef"
          />
        </h1>

        <div className="video-player__list">
          {videos.map((id) => (
            <div key={id} className="video-player__list__item">
              {activeVideo === id ? (
                <iframe
                  width="560"
                  height="315"
                  src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`}
                  title="YouTube video player"
                  allowFullScreen
                />
              ) : (
                <div
                  className="video-thumbnail"
                  onClick={() => setActiveVideo(id)}
                >
                  <img
                    src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`}
                    alt="Video thumbnail"
                  />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* <div className="video-player__list">
          <iframe
            src="https://www.youtube.com/embed/tSv04ylc6To"
            width="280"
            height="240"
            title="A YouTube video"
            frameborder="0"
            allowfullscreen
          ></iframe>


        </div> */}
      </div>
    </div>
  );
}

export default VideoPlayer;
